import { Logger } from '@aws-amplify/core';

const isDevelopment = process.env.NODE_ENV === 'development';

const logLevel = isDevelopment ? 'DEBUG' : 'WARN';
const logger = new Logger('[AT2SignIn]', logLevel);

export default logger;
